import { render, staticRenderFns } from "./modalSidebar.vue?vue&type=template&id=9473e716"
import script from "./modalSidebar.vue?vue&type=script&lang=js"
export * from "./modalSidebar.vue?vue&type=script&lang=js"
import style0 from "./modalSidebar.vue?vue&type=style&index=0&id=9473e716&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports